/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@material-ui/core/Button';

import { useSnackbar } from 'notistack';
import { formatPrice } from '../../../utils/format';
import make from '../../../utils/make';
import api from '../../../services/api';

import useStyles from './styles';

function Send({ number }) {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const dispatch = useDispatch();

  const distDefault = 101;
  const [dist, setDist] = useState(distDefault);
  const { company, loading, categories } = useSelector(state => state.data);
  const { adresses } = useSelector(state => state.adresses);
  const { order: current } = useSelector(state => state.order);

  useEffect(() => {
    function getDistance() {
      setDist(distDefault);
      try {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
            const { latitude, longitude } = position.coords;
            const origin = new window.google.maps.LatLng(latitude, longitude);
            const destiny = new window.google.maps.LatLng(
              company.latitude,
              company.longitude
            );
            const service = new window.google.maps.DistanceMatrixService();

            function callback(response, status) {
              if (status === window.google.maps.DistanceMatrixStatus.OK) {
                const { distance } = response.rows[0].elements[0];
                setDist(distance.value);
              }
            }

            service.getDistanceMatrix(
              {
                origins: [origin],
                destinations: [destiny],
                travelMode: 'DRIVING',
                unitSystem: window.google.maps.UnitSystem.METRIC,
                avoidTolls: false,
                avoidHighways: false,
              },
              callback
            );
          });
        }
      } catch (error) {
        setDist(distDefault);
      }
    }

    if (current.modality === 2) {
      getDistance();
    }
  }, [current.modality]);

  const handleConfirm = async () => {
    if (company.enabled !== 1) {
      enqueueSnackbar('Indisponível no momento', { variant: 'error' });

      return;
    }

    if (current.modality === 0 && current.subtotal < company.minimum_value) {
      const formattedMinimumValue = formatPrice(company.minimum_value);
      enqueueSnackbar(
        `O valor minimo para entrega é de ${formattedMinimumValue}`,
        { variant: 'error' }
      );

      return;
    }

    if (current.modality <= 1 && !current.address.validated) {
      enqueueSnackbar(
        'O bairro do endereço selecionado esta fora de nossa area de cobertura',
        { variant: 'error' }
      );

      return;
    }

    if (current.modality <= 1 && current.payment.cod === 0) {
      enqueueSnackbar('Selecione a forma de pagamento', { variant: 'error' });

      return;
    }

    if (current.modality === 2 && company.module === 'P' && !Number(number)) {
      enqueueSnackbar('Informe o número de sua comanda/mesa', {
        variant: 'error',
      });

      return;
    }

    if (current.modality === 2 && dist >= 101) {
      enqueueSnackbar('Você deve estar no local para efetuar o pedido', {
        variant: 'error',
      });

      return;
    }

    if (loading) return;

    dispatch({ type: '@data/LOADING' });

    const order = {
      number:
        current.modality === 2 && company.module === 'P' ? Number(number) : 0,
      modality: current.modality,
      address_id: current.modality <= 1 ? current.address.address_id : null,
      delivery: current.modality <= 1 ? current.delivery : 0,
      payment_id: current.modality <= 1 ? current.payment.payment_id : null,
      value: current.modality <= 1 ? current.payment.value : 0,
      items: make(current.items, categories),
    };

    try {
      const service = api(current.token);

      const res = await service.orderset(order);

      if (res && res.success) {
        dispatch({
          type: '@order/CONFIRMED',
          data: {
            token: current.token,
            adresses,
          },
        });

        dispatch({ type: '@data/LOADING' });

        enqueueSnackbar(
          'Recebemos o seu pedido e enviamos os detalhes no seu WhatsApp',
          { variant: 'success' }
        );

        return;
      }

      if (res && res.error) {
        dispatch({ type: '@data/LOADING' });
        enqueueSnackbar(res.error_message, { variant: 'error' });
        return;
      }

      dispatch({ type: '@data/LOADING' });

      enqueueSnackbar(
        'Houve uma falha interna e não foi possível salvar os dados do seu pedido. Tente mais tarde',
        { variant: 'error' }
      );
    } catch (error) {
      dispatch({ type: '@data/LOADING' });

      enqueueSnackbar(
        'Falha ao tentar enviar seu pedido. Verifique sua conexão com a internet',
        { variant: 'error' }
      );
    }
  };

  return (
    <div className={classes.root}>
      <Button
        className={classes.button}
        variant="contained"
        color="primary"
        onClick={handleConfirm}
      >
        fazer pedido
      </Button>
    </div>
  );
}

export default Send;
